/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "./SoftBox";
import SoftTypography from "./SoftTypography";
import {
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableContainer,
  TableRow,
} from "@mui/material";
import SoftButton from "./SoftButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Loading from "./Common/Loading";
import DataTableBodyCell from "./Common/DataTableBodyCell";
import DataTableHeadCell from "./Common/DataTableHeadCell";
export default function TableCommon({
  loading,
  query,
  setQuery,
  paginationData,
  setPaginationData,
  isSorted,
  noEndBorder,
  tableInstance,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    setPageSize,
    state: { pageSize },
  } = tableInstance;
  const totalPage = Math.ceil(paginationData?.count / pageSize);
  const countButton = [];
  if (paginationData) {
    for (let i = 0; i < totalPage; i++) {
      countButton.push(i);
    }
  }

  useEffect(() => {
    setPageSize(paginationData.size);
    setPaginationData((prev) => ({ ...prev, pageSize: paginationData.size }));
  }, []);

  const setSortedValue = (column) => {
    let sortedValue;
    if (isSorted && column.sorted) {
      sortedValue = column.isSortedDesc ? "desc" : "asce";
    } else {
      sortedValue = false;
    }
    return sortedValue;
  };

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      {loading ? (
        <SoftBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="500px"
          width="100%"
        >
          <Loading />
        </SoftBox>
      ) : (
        <>
          <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
            <SoftBox display="flex" alignItems="center">
              {query && Object.keys(query).length > 2 && !query.hasOwnProperty("searchBy") && (
                <SoftButton
                  display="block"
                  size="small"
                  variant="gradient"
                  color="info"
                  sx={{ marginLeft: 2 }}
                  onClick={() => {
                    setQuery && setQuery({ sortBy: "createdAt", sortType: "desc" });
                  }}
                >
                  Xóa lọc
                </SoftButton>
              )}
            </SoftBox>
          </SoftBox>
          <Table {...getTableProps()}>
            <SoftBox component="thead">
              {headerGroups?.map((headerGroup, key) => {
                return (
                  <TableRow key={key} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers?.map((column, key) => {
                      return (
                        <DataTableHeadCell
                          key={key}
                          {...column.getHeaderProps(isSorted && column.getSortByToggleProps())}
                          width={column.width ? column.width : "auto"}
                          align={column.align ? column.align : "left"}
                          sorted={setSortedValue(column)}
                        >
                          {column.render("Header")}
                        </DataTableHeadCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </SoftBox>
            <TableBody {...getTableBodyProps()}>
              {page?.map((row, key) => {
                prepareRow(row);
                return (
                  <TableRow key={key} {...row.getRowProps()}>
                    {row.cells.map((cell, key) => (
                      <DataTableBodyCell
                        key={key}
                        noBorder={noEndBorder && rows.length - 1 === key}
                        align={cell.column.align ? cell.column.align : "left"}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </DataTableBodyCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </>
      )}

      <SoftBox
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        p={3}
      >
        <SoftBox mb={{ xs: 3, sm: 0 }}>
          <SoftTypography variant="button" color="secondary" fontWeight="regular">
            Tổng {rows.length}
          </SoftTypography>
        </SoftBox>
        {countButton.length > 1 && (
          <Pagination
            count={countButton.length}
            color="secondary"
            page={paginationData.page}
            onChange={(e, value) => setPaginationData((prev) => ({ ...prev, page: value }))}
            renderItem={(item) => (
              <PaginationItem
                slots={{
                  previous: ArrowBackIcon,
                  next: ArrowForwardIcon,
                }}
                {...item}
              />
            )}
          />
        )}
      </SoftBox>
    </TableContainer>
  );
}
